export default {
  namespaced: true,
  state() {
    return {
      queue: [],
      nextNotificationId: 0,
      offset: { x: 0, y: 0 }
    };
  },
  mutations: {
    incrementNextNotificationId(state) {
      state.nextNotificationId++;
    },
    add(state, data) {
      state.queue.push(data);
    },
    remove(state, id) {
      let index = state.queue.findIndex(x => x.id === id);
      if (index > -1) state.queue.splice(index, 1);
    },
    setOffset(state, offset) {
      state.offset.x = offset.x;
      state.offset.y = offset.y;
    }
  },
  actions: {
    send({ state, commit }, { message, duration, type }) {
      let id = state.nextNotificationId + 0;
      commit("incrementNextNotificationId");
      commit("add", { id, message, type });

      if (duration === undefined) duration = 5000;
      if (duration) setTimeout(() => commit("remove", id), duration);
    },
    error({ dispatch }, message) {
      dispatch("send", { message, type: "error", duration: null });
    },
    success({ dispatch }, message) {
      dispatch("send", { message, type: "success", duration: 2000 });
    }
  }
};
